/* eslint-disable */
export default {
  topic: 'Meetingtitel',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
